import { v4 as uuidv4 } from 'uuid';
import { createTheme } from '@mui/material';

const addToIndustries = (newItems, formIndustries) => {
  formIndustries = [];
  newItems.forEach((industry) => {
    formIndustries.push({
      Industry: {
        Id: industry.IndustryId,
        Name: industry.value
      },
      IndustryId: industry.IndustryId,
      label: industry.value,
      value: industry.value
    });
  });

  return formIndustries;
};

const addToFunctions = (newItems, formFunctions) => {
  formFunctions = [];
  newItems.forEach((jobFunction) => {
    formFunctions.push({
      JobFunction: {
        Id: jobFunction.JobFunctionId,
        Name: jobFunction.value
      },
      JobFunctionId: jobFunction.JobFunctionId,
      label: jobFunction.value,
      value: jobFunction.value
    });
  });

  return formFunctions;
};

const isSkillUnique = (newItem, skillsArray) =>
  !skillsArray.find((item) =>
    typeof newItem === 'string' ? item.SkillName === newItem : item.SkillName === newItem.props.label
  );

const addToSkills = (newItemsArray, stringItem, formSkills) => {
  if (newItemsArray && newItemsArray.length) {
    newItemsArray.forEach((skill) => {
      if (isSkillUnique(skill, formSkills))
        formSkills.push({
          SkillName: skill.props.label,
          Name: skill.props.label,
          Id: uuidv4(10),
          TopSkill: false
        });
    });
  }

  if (isSkillUnique(stringItem, formSkills) && stringItem)
    formSkills.push({
      SkillName: stringItem,
      Name: stringItem,
      Id: uuidv4(20),
      TopSkill: false
    });

  return formSkills;
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#0194D3'
    }
  },
  color: 'white'
});

export { addToIndustries, addToFunctions, addToSkills, isSkillUnique, theme };
